import { injectable } from 'inversify';

@injectable()
export class LogoutAction {
  execute(): void {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  }
}
